export default __webpack_public_path__ + "static/media/apple-carousel-headline-box.9c4b2fd2.png";